import { KeyboardEvent, MouseEvent } from 'react'

import RemoveDoneIcon from '@mui/icons-material/RemoveDone'

import { CheckboxMenuItem } from '../CheckboxMenuItem/CheckboxMenuItem'
import { useCheckboxMenuContext } from '../context/CheckboxMenuContext'

export const CheckboxDeselectAllItem = <Data extends Record<string, unknown>>() => {
  const { closeMenu, deselectAll } = useCheckboxMenuContext<Data>()

  const handleDeselect = (e?: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => {
    e?.stopPropagation()
    deselectAll?.()
    closeMenu?.()
  }

  return <CheckboxMenuItem onClick={handleDeselect} text="Deselect All" icon={<RemoveDoneIcon />} />
}
